module.exports = __webpack_public_path__ + "static/img/top_1_3.7eb9e108.jpg";